import { render, staticRenderFns } from "./complaintRecordInfo.vue?vue&type=template&id=3e76fc5c&scoped=true&"
import script from "./complaintRecordInfo.vue?vue&type=script&lang=js&"
export * from "./complaintRecordInfo.vue?vue&type=script&lang=js&"
import style0 from "./complaintRecordInfo.vue?vue&type=style&index=0&id=3e76fc5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e76fc5c",
  null
  
)

component.options.__file = "complaintRecordInfo.vue"
export default component.exports